/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  BulkAssignDocumentBrandMutationRequest,
  BulkAssignDocumentBrandMutationResponse,
  BulkAssignDocumentBrand400,
} from '../types/BulkAssignDocumentBrand'

function getBulkAssignDocumentBrandUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/documents/bulk-assign-brand/` as const,
  }
  return res
}

/**
 * @description Bulk assign a brand to documents.
 * POST /documents/bulk-assign-brand/
 * Assign mode:
 * {
 * "brand_id": 5,
 * "document_ids": [1, 2, 3]
 * }
 * Unlink mode (set brand_id to null):
 * {
 * "brand_id": null,
 * "document_ids": [1, 2, 3]
 * }
 * @summary Bulk assign (or unlink) a brand on documents
 * {@link /api/v1/documents/bulk-assign-brand/}
 */
export async function bulkAssignDocumentBrand(
  data: BulkAssignDocumentBrandMutationRequest,
  config: Partial<RequestConfig<BulkAssignDocumentBrandMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    BulkAssignDocumentBrandMutationResponse,
    ResponseErrorConfig<BulkAssignDocumentBrand400>,
    BulkAssignDocumentBrandMutationRequest
  >({
    method: 'POST',
    url: getBulkAssignDocumentBrandUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
